// ---------------------------------------------------------------------------
// Blog Post Card Renderer
// ---------------------------------------------------------------------------

import { registerRenderer } from "../registry.js";
import type { RenderContext } from "../types.js";
import { attr, text, url } from "../escape.js";

interface BlogPostCardProps {
  title: string;
  excerpt?: string;
  featuredImage?: string;
  publishedAt?: string;
  authorName?: string;
  authorUrl?: string;
  category?: string;
  slug: string;
  readingTimeMinutes?: number;
  ctaText?: string;
}

function render(props: Record<string, unknown>, _ctx: RenderContext): string {
  const p = props as unknown as BlogPostCardProps;

  const title = p.title ?? "";
  const slug = p.slug ?? "#";
  const ctaText = p.ctaText ?? "Read More";

  const imageHtml = p.featuredImage
    ? `\n    <img src="${url(p.featuredImage)}" alt="${attr(title)}" class="ease-blog-card-image" loading="lazy">`
    : "";

  const categoryHtml = p.category
    ? `\n    <span class="ease-blog-card-category">${text(p.category)}</span>`
    : "";

  const excerptHtml = p.excerpt
    ? `\n    <p class="ease-blog-card-excerpt">${text(p.excerpt)}</p>`
    : "";

  const dateHtml = p.publishedAt
    ? `<time class="ease-blog-card-date" datetime="${attr(p.publishedAt)}">${text(p.publishedAt)}</time>`
    : "";

  const authorHtml = p.authorName
    ? p.authorUrl
      ? `<a href="${url(p.authorUrl)}" class="ease-blog-card-author">${text(p.authorName)}</a>`
      : `<span class="ease-blog-card-author">${text(p.authorName)}</span>`
    : "";

  const readingHtml = p.readingTimeMinutes
    ? `<span class="ease-blog-card-reading-time">${text(String(p.readingTimeMinutes))} min read</span>`
    : "";

  const metaParts = [dateHtml, authorHtml, readingHtml].filter(Boolean);
  const footerHtml = metaParts.length > 0
    ? `\n    <footer class="ease-blog-card-footer">${metaParts.join(" &middot; ")}</footer>`
    : "";

  return `<article class="ease-blog-card" aria-label="${attr(title)}">${imageHtml}${categoryHtml}
    <h3 class="ease-blog-card-title"><a href="${url(slug)}">${text(title)}</a></h3>${excerptHtml}${footerHtml}
    <a href="${url(slug)}" class="ease-blog-card-cta">${text(ctaText)}</a>
</article>`;
}

registerRenderer("blog-post-card", { render });
